exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bin_image img{cursor:pointer}.kedvenciam_all_small_can{text-align:right}.kedvenciam_all_small_can img{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7f9e32c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/dashboard/wishlist/Wishlist.vue
// module id = 265
// module chunks = 2